import React from "react";

function ModalConfirmation({
  isOpen, onClose, onConfirm, message,
  title = "Confirmar acción", confirmText = "Confirmar", cancelText = "Cancelar",
  variant = "primary", icon,
}) {
  if (!isOpen) return null;
  const variants = {
    primary: { iconBg:"bg-sirius-50 text-sirius-600", iconDefault:"fa-circle-question",
      btn:"bg-gradient-to-br from-sirius-600 to-spark-500 hover:from-sirius-700 hover:to-spark-600 shadow-spark" },
    danger:  { iconBg:"bg-red-50 text-red-600", iconDefault:"fa-triangle-exclamation",
      btn:"bg-gradient-to-br from-rose-600 to-red-600 hover:from-rose-700 hover:to-red-700 shadow-[0_8px_25px_-8px_rgba(239,68,68,0.55)]" },
    warning: { iconBg:"bg-amber-50 text-amber-600", iconDefault:"fa-circle-exclamation",
      btn:"bg-gradient-to-br from-amber-500 to-orange-500 hover:from-amber-600 hover:to-orange-600 shadow-[0_8px_25px_-8px_rgba(245,158,11,0.55)]" },
  };
  const v = variants[variant] || variants.primary;
  const iconClass = icon || v.iconDefault;
  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center p-4"
      style={{ backgroundColor:"rgba(13,13,16,0.55)", backdropFilter:"blur(6px)", WebkitBackdropFilter:"blur(6px)" }}
      onClick={onClose}>
      <div className="relative w-full max-w-md bg-white rounded-2xl shadow-sirius-lg border border-slate-200/70 overflow-hidden animate-sirius-fade-up"
        style={{ fontFamily:"Kanit, sans-serif" }} onClick={(e)=>e.stopPropagation()}>
        <div className="pointer-events-none absolute -top-20 -right-20 w-48 h-48 bg-spark-500/8 blur-3xl rounded-full" />
        <div className="relative p-6">
          <div className="flex items-start gap-4">
            <div className={`shrink-0 w-12 h-12 rounded-xl flex items-center justify-center text-xl ${v.iconBg}`}>
              <i className={`fas ${iconClass}`} />
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="font-display font-bold text-lg text-ink-900 leading-tight">{title}</h3>
              <p className="text-ink-600 text-sm mt-1.5 leading-relaxed">{message || "¿Estás seguro de que deseas continuar?"}</p>
            </div>
          </div>
          <div className="mt-6 flex justify-end items-center gap-2">
            <button type="button" onClick={onClose}
              className="inline-flex items-center justify-center px-4 py-2.5 rounded-xl text-sm font-semibold text-ink-700 bg-slate-100 hover:bg-slate-200 transition-all">{cancelText}</button>
            <button type="button" onClick={onConfirm}
              className={`inline-flex items-center justify-center gap-1.5 px-5 py-2.5 rounded-xl text-sm font-semibold text-white transition-all hover:-translate-y-0.5 ${v.btn}`}>
              {confirmText}<i className="fas fa-check text-[10px]" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
export default ModalConfirmation;
